import { Inject, Injectable, Optional } from '@angular/core';
import {
  MAT_DATE_LOCALE,
  DateAdapter,
} from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';

@Injectable()
export class SingleLetterMomentDateAdapter extends MomentDateAdapter {
  constructor(
    @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string,
    @Optional()
    @Inject(MAT_MOMENT_DATE_ADAPTER_OPTIONS)
    options?: any
  ) {
    super(dateLocale, options);
  }

  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    // You can also call super.getDayOfWeekNames('short') and slice,
    // but this is simple and works for all locales.
    const original = super.getDayOfWeekNames(style);
    return original.map(name => name.charAt(0));
  }
}
